// extracted by mini-css-extract-plugin
export var locationCard = "_qr-0";